import React from 'react';
import { Link } from 'react-router-dom';

const LINKTREE_URL = 'https://linktr.ee/athacado68';
const WHATSAPP_NUMBER = '557131766882';
const SUPPORT_WHATSAPP_NUMBER = '557131766870';
const WHATSAPP_MESSAGE = 'Olá! Vim do portal do cliente e gostaria de mais informações sobre o meu pedido.';
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
const SUPPORT_WHATSAPP_LINK = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer__columns">
        <div className="app-footer__column">
          <h4>Modelos</h4>
          <ul>
            <li><a href={LINKTREE_URL} target="_blank" rel="noopener noreferrer">Athacado 68</a></li>
            <li><Link to="/pedidos">Pedidos</Link></li>
            <li><Link to="/consulta">Consulta</Link></li>
            <li><Link to="/dashboard">Dashboard</Link></li>
          </ul>
        </div>

        <div className="app-footer__column">
          <h4>Sobre</h4>
          <ul>
            <li><a href={LINKTREE_URL} target="_blank" rel="noopener noreferrer">Athacado</a></li>
            <li><a href={LINKTREE_URL} target="_blank" rel="noopener noreferrer">Notícias</a></li>
          </ul>
        </div>

        <div className="app-footer__column">
          <h4>Atendimento</h4>
          <ul>
            <li><a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
            <li><a href={SUPPORT_WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">Central de Relacionamento</a></li>
            <li><a href={SUPPORT_WHATSAPP_LINK} target="_blank" rel="noopener noreferrer">SAC</a></li>
          </ul>
        </div>

        <div className="app-footer__column">
          <h4>Siga a Athacado 68</h4>
          <div className="app-footer__social-list">
            <a href={LINKTREE_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook Athacado 68" className="social-icon social-icon--facebook">
              <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M22 12.07C22 6.52 17.52 2 12 2S2 6.52 2 12.07c0 4.98 3.66 9.1 8.44 9.92v-7.03H8.01v-2.89h2.43V9.5c0-2.4 1.43-3.72 3.63-3.72 1.05 0 2.14.18 2.14.18v2.36h-1.2c-1.18 0-1.55.73-1.55 1.48v1.77h2.64l-.42 2.89h-2.22v7.03C18.34 21.17 22 17.05 22 12.07z"/></svg>
            </a>
            <a href="https://www.instagram.com/atacado68oficial" target="_blank" rel="noopener noreferrer" aria-label="Instagram Athacado 68" className="social-icon social-icon--instagram">
              <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zm8.73 2.22a1.04 1.04 0 110 2.08 1.04 1.04 0 010-2.08zm-4.23 1.2a5.53 5.53 0 015.5 5.5 5.53 5.53 0 01-5.5 5.5 5.53 5.53 0 01-5.5-5.5 5.53 5.53 0 015.5-5.5zm0 1.5a4.03 4.03 0 00-4 4 4.03 4.03 0 004 4 4.03 4.03 0 004-4 4.03 4.03 0 00-4-4z"/></svg>
            </a>
            <a href={LINKTREE_URL} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Athacado 68" className="social-icon social-icon--linkedin">
              <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M4.98 3.5A2.5 2.5 0 002.5 6a2.5 2.5 0 002.48 2.5A2.5 2.5 0 007.5 6a2.5 2.5 0 00-2.52-2.5zM3 8.75h3.96V21H3V8.75zM9.75 8.75H13v1.68h.05c.43-.8 1.5-1.65 3.08-1.65 3.3 0 3.9 2.18 3.9 5.02V21h-3.96v-5.4c0-1.29-.02-2.95-1.8-2.95-1.8 0-2.07 1.4-2.07 2.85V21H9.75V8.75z"/></svg>
            </a>
          </div>
        </div>
      </div>

      <div className="app-footer__bar">
        <p>© {new Date().getFullYear()} Athacado 68. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}

export default Footer;
